var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useTheme } from '@mui/material/styles';
import { colorPalette } from '../../colorPalette';
import DesktopStepper from '@mui/material/Stepper';
import MobileStepper from '@mui/material/MobileStepper';
import MuiStepLabel from '@mui/material/StepLabel';
import Step from '@mui/material/Step';
import StepContent from '@mui/material/StepContent';
import Box from '@mui/material/Box';
import { getStepperStyles } from './Stepper.style';
import CheckIcon from '@mui/icons-material/Check';
export const StepIcon = ({ isActive, isCompleted, size }) => {
    const theme = useTheme();
    return (React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '-3px' } },
        !isCompleted && !isActive ? (React.createElement(Box, { sx: [
                size === 'small' && { width: '24px', height: '24px' },
                size === 'medium' && { width: '32px', height: '32px' },
                { color: colorPalette.gray200, borderRadius: '16px', border: 'solid 2px', backgroundColor: 'white', zIndex: 99 },
            ] })) : null,
        isCompleted ? (React.createElement(Box, { sx: [
                size === 'small' && { width: '24px', height: '24px' },
                size === 'medium' && { width: '32px', height: '32px' },
                {
                    backgroundColor: theme.palette.primary.main,
                    borderRadius: '16px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 99,
                },
            ] },
            React.createElement(CheckIcon, { sx: [
                    size === 'small' && { width: '16px', height: '16px' },
                    size === 'medium' && { width: '24px', height: '24px' },
                    { color: 'white' },
                ] }))) : null,
        isActive ? (React.createElement(Box, { sx: [
                size === 'small' && { width: '24px', height: '24px' },
                size === 'medium' && { width: '32px', height: '32px' },
                {
                    color: theme.palette.primary.main,
                    borderRadius: '16px',
                    border: 'solid 2px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'white',
                    zIndex: 99,
                },
            ] },
            React.createElement(Box, { sx: [
                    size === 'small' && { width: '8px', height: '8px' },
                    size === 'medium' && { width: '12px', height: '12px' },
                    {
                        backgroundColor: theme.palette.primary.main,
                        borderRadius: '16px',
                    },
                ] }))) : null));
};
export const StepLabel = ({ children, isActive, isCompleted, optional, size }) => {
    return (React.createElement(MuiStepLabel, { icon: React.createElement(StepIcon, { isActive: isActive, isCompleted: isCompleted, size: size }), optional: optional }, children));
};
const HorizontalStepper = (_a) => {
    var { steps, activeStep = 0, size = 'small', sx } = _a, rest = __rest(_a, ["steps", "activeStep", "size", "sx"]);
    return (React.createElement(DesktopStepper, Object.assign({ orientation: "horizontal", activeStep: activeStep, alternativeLabel: true, sx: getStepperStyles(sx, size, 'horizontal') }, rest), steps.map((step, index) => (React.createElement(Step, { key: step === null || step === void 0 ? void 0 : step.stepNumber },
        React.createElement(StepLabel, { size: size, isActive: activeStep === index, isCompleted: activeStep > index }, step.stepNumber),
        step.label ? React.createElement(StepContent, { TransitionProps: { unmountOnExit: false } }, step.label) : null)))));
};
const VerticalStepper = (_a) => {
    var { steps, activeStep = 0, size = 'small', sx } = _a, rest = __rest(_a, ["steps", "activeStep", "size", "sx"]);
    return (React.createElement(DesktopStepper, Object.assign({ "data-qa": "stepper-vertical", orientation: "vertical", activeStep: activeStep, sx: getStepperStyles(sx, size, 'vertical') }, rest), steps.map((step, index) => (React.createElement(Step, { key: step.label },
        React.createElement(StepLabel, { size: size, isActive: activeStep === index, isCompleted: activeStep > index }, step.stepNumber),
        step.label ? React.createElement(StepContent, { TransitionProps: { unmountOnExit: false } }, step.label) : null)))));
};
export const Stepper = (_a) => {
    var { variant, steps, activeStep = 0, size } = _a, rest = __rest(_a, ["variant", "steps", "activeStep", "size"]);
    switch (variant) {
        case 'horizontal':
            return (React.createElement(HorizontalStepper, Object.assign({ steps: steps, activeStep: activeStep, size: size }, rest)));
        case 'vertical':
            return (React.createElement(VerticalStepper, Object.assign({ steps: steps, activeStep: activeStep, size: size }, rest)));
        case 'dots':
        case 'text':
            return (React.createElement(MobileStepper, Object.assign({ "data-qa": `stepper-${variant}`, variant: variant, steps: steps, position: "static", activeStep: activeStep, nextButton: null, backButton: null }, rest)));
        default:
            return null;
    }
};
